export default __webpack_public_path__ + "static/media/fondo.bd94b7db.jpg";